import { defineStore } from "pinia";
// Type imports
import type {
	Application,
	Currency
} from "@nwt/norce-pwa/dist/runtime/types/api/application/application";
import type { SbBlokData } from "@storyblok/js";
import type {
	Account,
	Search,
	SiteLogo,
	ApplicationFlag,
	Asset,
	MaterialsGroup
} from "~/types/storyblok/storyblok";
import type {
	MenuCategories,
	MenuCategoriesNorce,
	SiteLogoDimensions,
	CulturesNorce
} from "~/types/components/header";

interface State {
	siteLogo: SiteLogo | undefined;
	siteLogoDimensions: SiteLogoDimensions;
	search: Search[];
	account: Account[];
	menuCategories: MenuCategories;
	menuCategoriesNorce: MenuCategoriesNorce;
	applicationNorce: Application | null;
	culturesNorce: CulturesNorce[];
	currenciesNorce: Currency[];
	headerLoaded: boolean;
	flags: ApplicationFlag[];
	materials: MaterialsGroup[];
	gallery: Asset[];
	topBar: SbBlokData[];
	footerLogo: SiteLogo | undefined;
}

export const useAppStore = defineStore("appStore", {
	state: (): State => ({
		siteLogo: undefined,
		siteLogoDimensions: {
			width: 100,
			height: 20
		},
		search: [],
		account: [],
		menuCategories: {
			left: [],
			right: []
		},
		menuCategoriesNorce: {
			left: [],
			right: []
		},
		applicationNorce: null,
		culturesNorce: [],
		currenciesNorce: [],
		headerLoaded: false,
		flags: [],
		materials: [],
		gallery: [],
		topBar: [],
		footerLogo: undefined
	}),

	getters: {
		getAppStore: (state) => state
	},

	actions: {
		initState(data: Partial<State>) {
			this.$patch((state) => {
				if (data.siteLogo) state.siteLogo = data.siteLogo;
				if (data.siteLogoDimensions) {
					state.siteLogoDimensions = {
						...state.siteLogoDimensions,
						...data.siteLogoDimensions
					};
				}
				if (data.search) state.search = data.search;
				if (data.account) state.account = data.account;
				if (data.menuCategories) state.menuCategories = data.menuCategories;
				if (data.menuCategoriesNorce)
					state.menuCategoriesNorce = data.menuCategoriesNorce;
				if (data.applicationNorce)
					state.applicationNorce = data.applicationNorce;
				if (data.culturesNorce) state.culturesNorce = data.culturesNorce;
				if (data.currenciesNorce) state.currenciesNorce = data.currenciesNorce;
				if (data.headerLoaded) state.headerLoaded = data.headerLoaded;
				if (data.flags) state.flags = data.flags;
				if (data.materials) state.materials = data.materials;
				if (data.gallery) state.gallery = data.gallery;
				if (data.topBar) state.topBar = data.topBar;
				if (data.footerLogo) state.footerLogo = data.footerLogo;
			});
		}
	}
});
